import { create } from 'zustand';

import { ColumnState } from 'ag-grid-community';
import { EmployeeCreateRequestDto } from '../dtos/user/request/employCreateRequestDto';
import { CompanyDto } from '../dtos/company/companyDto';
import { UserResponseDto } from '../dtos/user/response/userResponseDto';
import { formatDate } from 'src/utils/string/stringUtil';

export interface UserStore {

    userInfo: UserResponseDto | undefined;
    setUserInfo: (userInfo: UserResponseDto) => void;

    company: CompanyDto | undefined;
    setCompany: (company: CompanyDto | undefined) => void;

	setUserInCompanyList: (companyList: CompanyDto[]) => void;

    initData: () => void;
}

export interface UserData extends EmployeeCreateRequestDto {
    inserted?: boolean;
    isModified?: boolean;
    empNm?: string;
    compNm?: string;
    orgNm?: string;
    autGroupNm: string;
    hovered?: boolean;
	selected?: boolean;
}

/**
 * 기본 사용자 데이터
 * 새로운 사용자 생성 시 사용되는 기본값
 */
export const defaultUserData: UserData = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
    userId: "",
    userNm: "",
    orgCd: "",
    compCd: "",
    empNo: "",
    compAut: "N",
    costAut: "Y",
    approveAut: "Y",
    deleteAut: "Y",
    autGroupCd: "",
    lockSts: "Y",
    password: "",
    passUpdate: formatDate(new Date()),
    menuAuth: "",
    bookMark: "",
    workplaceCd: "",
    remark: "",
    autGroupNm: "",
    menuAuthNm: "",
    detailAddress: "",
    inserted: true,
}

/**
 * 사용자 관리 스토어
 * 사용자 관련 상태와 액션을 관리
 */
const useUserStore = create<UserStore>((set) => ({
	
    userInfo: undefined,
    setUserInfo: (userInfo: UserResponseDto) => set({ userInfo }),

    company: undefined,
    setCompany: (company: CompanyDto | undefined) => set({ company }),
	setUserInCompanyList: (companyList: CompanyDto[]) => set((state) => ({
		...state,
		company: companyList.find(company => company.compCd === state.userInfo?.compCd)
	})),

    initData: () => set((state) => ({
        ...state,
        userList: [],
        selectedUserList: [],
        deletedUserList: []
    }))
}));

export default useUserStore;